module.exports = __webpack_public_path__ + "img/red-wine-spritzer.f2a1fdc5.jpg";